// extracted by mini-css-extract-plugin
module.exports = {"Suspicious":"WarningSuspicious_Suspicious__aSE0s","Button":"WarningSuspicious_Button__2ub0d","Closed":"WarningSuspicious_Closed__20Q__"};